import { Team__Coyotes } from "../teams/Coyotes";
import { Team__Cerveceros } from "../teams/Cerveceros";

const Coyotes = {
  team: Team__Coyotes,
  playingPlayers: [],

  goals: 57,
  penaltyGoals: 0,
  isWinner: false,
};


const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 42,
  penaltyGoals: 0,
  isWinner: false,
};


export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Coyotes,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Sábado",
      date: "2026-08-01",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
